import CreateQuestionPaper from "pages/dashboard/shared/Question Paper/QuestionPaper/CreateQuestionPaper";

const AdminCreateQuestionPaper = () => {
  return <CreateQuestionPaper />;
};

export default AdminCreateQuestionPaper;
